import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stats-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stats-bar.component.html',
  styleUrl: './stats-bar.component.scss'
})
export class StatsBarComponent {
  stats = [
    {
      stat: '25+ YEARS',
      title: 'EXPERIENCE YOU CAN BUILD ON',
      description: 'Construction Industry Experience',
      icon: 'award'
    },
    {
      stat: 'CUSTOM',
      title: 'DESIGNED FOR YOU',
      description: 'Homes Designed Around You',
      icon: 'home'
    },
    {
      stat: 'PERSONALISED',
      title: 'START TO FINISH',
      description: 'Service From Start to Finish',
      icon: 'user-check'
    },
    {
      stat: 'QUALITY',
      title: 'ATTENTION TO DETAIL',
      description: 'Craftsmanship & Attention to Detail',
      icon: 'shield-check'
    }
  ];
}
